<template>
    <div class="class-list">
        <GlobalInfoBar title="商户充值记录" content="可在此处查看和处理商户充值记录" />
        <div class="button_top">
            <div class="radiobtn">
                <div class="faultBtn">
                    <div v-bind:class="this.clickShow === '01' ? 'left' : 'right'" @click="BtnClick('active')">
                        待上账({{ statisticsNum[0] || 0 }})
                    </div>
                    <div v-bind:class="this.clickShow === '02' ? 'left' : 'right'" @click="BtnClick('before')">
                        已上账({{ statisticsNum[1] || 0 }})
                    </div>
                </div>
            </div>
        </div>
        <div style="margin-bottom: 10px;color: #FF687B;font-size: 14px;">
            说明：商户通过银行卡转账后，若此银行卡已添加充值白名单中，此次充值将自动执行上账和自动核账，若未添加至白名单，此次充值需手动处理上账，处理后需手动核账；
        </div>
        <div class="button_top" v-if="clickShow == '01'">
            <div class="radiobtn">
                <div class="faultBtn">
                    <div v-bind:class="payClickShow === '01' ? 'left' : 'right'" @click="BtnPayClick('active')">
                        未识别({{ obj.noIdentifyNum || 0 }})
                    </div>
                    <div v-bind:class="payClickShow === '02' ? 'left' : 'right'" @click="BtnPayClick('before')">
                        已识别({{ obj.identifyNum|| 0 }})
                    </div>
                </div>
            </div>
        </div>
        <GlobalChunk icon="search" title="筛选查询" v-if="clickShow == '01' && payClickShow == '01'">
            <div slot="filter">
                <transferFrom />
            </div>
            <transferTable @data-loaded="handleData" @params="handleparams"/>
        </GlobalChunk>
        <!-- <Info/> -->

      <GlobalChunk icon="search" title="筛选查询" v-if="clickShow=='01' && payClickShow == '02'">
        <div slot="filter">
          <payFrom />
        </div>
        <payTable @params="handleparams" />
      </GlobalChunk>
      <GlobalChunk icon="search" title="筛选查询" v-if="clickShow=='02'">
        <div slot="filter">
          <refundListFrom />
        </div>
            <!-- <transferTable @data-loaded="handleData" @params="handleparams"/> -->
            <refundListTable @params="handleparams" />
      </GlobalChunk>
    </div>
</template>

<script>
import transferFrom from "./transferList/Form";
import transferTable from "./transferList/Table";
  import refundListFrom from "./refundList/Form";
  import refundListTable from "./refundList/Table";
  import payFrom from "./pay/Form";
  import payTable from "./pay/Table";
  import {_http} from "@/utils/request/rechargeRecord";
export default {
    name: "class-list",
    components: {
        transferFrom,
        transferTable,
          refundListFrom,
          refundListTable,
          payFrom,
          payTable
    },
    data() {
        return {
            clickShow: '01',
            payClickShow: '01',
            statisticsNum: [],
            obj:{},
            params:{}
        };
    },
    created() {
        this.$store.commit("tagsView/SEACH_PARAMS", {})
        // this.getStatisticsNum()
    },
    
    methods: {
        BtnClick(type) {
            // this.$store.commit("tagsView/SEACH_PARAMS", {});
            // this.getStatisticsNum()
            if (type === 'active') {
                this.clickShow = '01'
                this.payClickShow = '01'
            } else {
                this.clickShow = '02'
                this.payClickShow = '01'
            }
        },
        BtnPayClick(type) {
            // this.$store.commit("tagsView/SEACH_PARAMS", {});
            //  this.getStatisticsNum()
            if (type === 'active') {
                this.payClickShow = '01'
            } else {
                this.payClickShow = '02'
            }
        },
        getStatisticsNum() {
            console.log(this.params, "发货和国防经济环境")
            _http.getNum({ rechargeTimeStart:this.params.startTime,rechargeTimeEnd:this.params.endTime,createTimeStart:this.params.startTimeInfo,createTimeEnd:this.params.endTimeInfo}).then(res => {
              if(res.code === 1){
                this.statisticsNum = res.data
              }
            })
        },
        handleData(obj){
            this.obj=obj
        },
        handleparams(obj){
            this.params=obj
            this.getStatisticsNum()
        }
    },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.class-list {
    .button_top {
        cursor: pointer;
        margin-bottom: 20px;
        ;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .faultBtn {
        width: 280px;
        height: 32px;
        background: #F9FBFD;
        border: 1px solid #C1D1FF;
        box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
        border-radius: 21px;
        display: flex;

        .left {
            text-align: center;
            color: white;
            width: 50%;
            height: 14px;
            font-size: 14px;
            font-family: FZLanTingHei-M-GBK;
            font-weight: 400;
            line-height: 30px;
            height: 30px;
            background: #0981FF;
            border-radius: 20px;
        }

        .right {
            text-align: center;
            color: #333;
            width: 50%;
            height: 14px;
            font-size: 14px;
            font-family: FZLanTingHei-M-GBK;
            font-weight: 400;
            line-height: 30px;
            height: 30px;
            border-radius: 20px;
        }
    }

    .faultBtn1 {
        width: 280px;
        height: 32px;
        display: flex;

        .left {
            position: relative;
            text-align: center;
            color: #0981FF;
            width: 50%;
            height: 14px;
            font-size: 16px;
            font-family: FZLanTingHei-M-GBK;
            font-weight: 700;
            line-height: 30px;
            height: 30px;
            border-radius: 20px;

            &::before {
                content: "";
                width: 55px;
                height: 3px;
                border-radius: 1px;
                background-color: #5a8eff;
                position: absolute;
                top: 32px;
                left: 30%;
            }
        }

        .right {
            text-align: center;
            color: #333;
            width: 50%;
            height: 14px;
            font-size: 14px;
            font-family: FZLanTingHei-M-GBK;
            font-weight: 400;
            line-height: 30px;
            height: 30px;
            border-radius: 20px;
        }
    }
}
</style>